var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex-1 px-3 py-5 sm:px-12 sm:py-8 font-outfit" },
    [
      _vm._m(0),
      _c("div", { staticClass: "flex flex-col gap-4 sm:gap-5" }, [
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Short Term")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [_vm._v(_vm._s(_vm.data.short_term_goals || "N/A"))]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Long Term")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [_vm._v(_vm._s(_vm.data.long_term_goals || "N/A"))]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Special Care Needs")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [_vm._v(_vm._s(_vm.data.specific_care_needs || "N/A"))]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Outcomes")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [_vm._v(_vm._s(_vm.data.desired_outcomes || "N/A"))]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Self Directed Care")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [_vm._v(_vm._s(_vm.data.self_directed_care_preferences || "N/A"))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass:
          "justify-between items-center mb-4 pb-4 borderMainClientProfile hidden sm:flex",
      },
      [_c("h2", { staticClass: "text-lg font-normal" }, [_vm._v("Care Goals")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }